import { sortDevices } from '@/js/utils';

const deviceData = (state) => state.deviceData;

// 0 - All Devices
// 1 - My Devices
// 2 - Shared Devices
const sortedDevices = (state) => (sortCriteria, deviceTab) => {
  if (
    !Array.isArray(state.deviceData) ||
    !Array.isArray(state.sharedDeviceData)
  ) {
    return null;
  }
  let devices = [];
  if (deviceTab === 1) {
    devices = state.deviceData.slice();
  } else if (deviceTab === 2) {
    devices = state.sharedDeviceData.slice();
  } else {
    devices = state.deviceData.slice().concat(state.sharedDeviceData.slice());
  }
  return devices.sort((a, b) => sortDevices(a, b, sortCriteria));
};

const numOfDevices = (state) => (state.deviceData || []).length;

const shareDeviceUsers = (state) => (devId) =>
  (state.shareDevice.find((device) => device.dev_id === devId) || {}).users;

const sharedDeviceData = (state) => state.sharedDeviceData;

const isSharedDevice = (state) => (devId) =>
  state.sharedDeviceData &&
  state.sharedDeviceData.some((device) => device.dev_id === devId);

const sharedDeviceInfo = (state) => (devId) =>
  Array.isArray(state.sharedDeviceData) &&
  state.sharedDeviceData.find((device) => device.dev_id === devId);

export default {
  deviceData,
  sortedDevices,
  numOfDevices,
  sharedDeviceData,
  shareDeviceUsers,
  isSharedDevice,
  sharedDeviceInfo,
};
